import { Directive } from '@angular/core';
import { ResourceBuilderComponent } from '@klickdata/shared-components';
import { ResourceComposerDirective } from './resource-composer-directive';

@Directive()
export abstract class ResourceBuilderComposerDirective extends ResourceComposerDirective {
    abstract get resourceBuilder(): ResourceBuilderComponent;
}
